/*
 * @Descripttion:
 * @Author: zenghua.wang
 * @Date: 2021-06-30 17:13:48
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2021-10-29 14:45:00
 */
const iconPre = './cdn/mxgraph/images/icon'
export const buttons = [
  {
    title: '保存',
    name: 'save',
    icon: `${iconPre}/save.png`,
    evt: 'onSave'
  },
  {
    title: '删除',
    name: 'delete',
    icon: `${iconPre}/delete.png`,
    evt: 'deleteCell'
  },
  // {
  //   title: '撤销',
  //   name: 'undo',
  //   icon: `${iconPre}/undo.png`,
  //   evt: 'undoCell'
  // },
  // {
  //   title: '重做',
  //   name: 'redo',
  //   icon: `${iconPre}/redo.png`,
  //   evt: 'redoCell'
  // },
  {
    title: 'XML切换',
    name: 'xml',
    icon: `${iconPre}/xml.png`,
    evt: 'getCell'
  },
  {
    title: 'XML导入',
    name: 'import',
    icon: `${iconPre}/import.png`,
    evt: 'importCell'
  },
  {
    title: '测试',
    name: 'test',
    icon: `${iconPre}/test.png`
  },
  {
    title: '调试',
    name: 'debug',
    icon: `${iconPre}/debug.png`
  },
  {
    title: '下一步',
    name: 'next',
    icon: `${iconPre}/next.png`
  },
  {
    title: '暂停',
    name: 'stop',
    icon: `${iconPre}/stop.png`
  },
  {
    title: '返回',
    name: 'back',
    icon: `${iconPre}/back.png`,
    evt: 'onCancel'
  }
]
